export default function (other) {
  other = other || {}
  return {
    id: other.id || null,
    title: other.title || null,
    description: other.description || null,
    type: other.type || null,
    status: other.status || null,
    priority: other.priority || null,
    participants: other.participants || [],
    createdBy: other.createdBy || null,
    createdByName: other.createdByName || null,
    assignedTo: other.assignedTo || null,
    orgId: other.orgId || null,
    creationTime: other.creationTime || null,
    lastUpdate: other.lastUpdate || null,
    comments: other.comments || [],
    attachments: other.attachments || [],
  }
}
